export const API_URL = {
    // Auth
    SIGN_UP: 'signup',
    VERIFY_SIGNUP_OTP: 'verifyOtp',
    LOG_IN: 'user/sendOtp',
    VERIFY_LOGIN_OTP: 'user/verifyOtp',
    LOGOUT: 'user/logout',
    SIGNUP_PROFILE_UPDATE: 'userProfile/signupProfileUpdate',
    UPLOAD_KYC_DOCUMENT: 'userProfile/uploadKyc',
    
    // General
    GET_PROFILE_CATEGORY_LIST: 'profileCategory/getList',
    GET_LOCATION_LIST: 'location/getList',
    GET_PROJECT_CATEGORY_LIST: 'projectCategory/getList',
    GET_ROLE_TYPE_LIST: 'roleType/getList',
    GET_REPORT_TYPE_LIST: 'report/getList',
    REPORT_PROFILE: 'report/profile',
    REPORT_JOB: 'report/job',

    // Audition Panel
    GET_AUDITIONS_LIST: 'job/getList',
    GET_JOB_APPLICANTS: 'job/getApplicants',
    MARK_JOB_COMPLETE: 'job/markComplete',
    UPDATE_JOB: 'job/update',
    ADD_JOB: 'job/add',
    ACTIVATE_JOB: 'job/activate',
    REACTIVATE_JOB: 'job/reactivate',
    MARK_APPLICANT_SHORTLIST: 'project/profile/markShortlist',
    MARK_APPLICANT_FINAL: 'job/profile/markFinal',

    // Project Panel
    ADD_PROJECT: 'project/add',
    UPDATE_PROJECT: 'project/update',
    GET_ACTIVE_PROJECT_LIST: 'project/getActive',

    // Artist Panel
    GET_ARTIST_LIST: 'profile/getArtistsList',
    GET_PROFILE_BY_ID: 'profile/get',
    GET_WORK_DONE_LIST_BY_ID: 'workdone/getList',
    MARK_PROFILE_FAVORITE: 'profile/markFavourite',
    REQUEST_CONTACT: 'request/add',

    // NOTES
    ADD_NOTE: 'note/add',
    UPDATE_NOTE: 'note/update',
    DELETE_NOTE: 'note/delete',
    GET_NOTE_LIST: 'note/getList',
    
    // Media
    GET_MEDIA_LIST: 'media/getMediaList',
    PIN_MEDIA: 'media/pin',
    DELETE_MEDIA: 'media/delete',
    UPLOAD_MEDIA: 'media/upload',
    UPLOAD_VIDEO: 'media/uploadVideo',

    // Notification
    ADD_NOTIFICATION: 'notification/add',
    GET_NOTIFICATIONS: 'notification/getNotification',
    UPDATE_FCM_TOKEN: 'fcmToken/update',

    // Profile
    GET_PROFILE_DATA: 'userProfile/get',
    UPLOAD_PROFILE_PIC: 'userProfile/upload/profilePic',
    ADD_FAME_DATA: 'fame/addFame',
    UPDATE_FAME_DATA: 'fame/updateFame',
    DELETE_FAME_DATA: 'fame/deleteFame',
    ADD_ASSOCIATED_WITH: 'associatedWith/addAssociatedWith',
    UPDATE_ASSOCIATED_WITH: 'associatedWith/updateAssociatedWith',
    DELETE_ASSOCIATED_WITH: 'associatedWith/deleteAssociatedWith',
    UPDATE_PROFILE: 'userProfile/update',

    // Contact
    GET_REQUEST_LIST: 'request/getList',

    // Folders
    ADD_FOLDER: 'folder/add',
    UPDATE_FOLDER: 'folder/update',
    DELETE_FOLDER: 'folder/delete',
    GET_FOLDER_LIST: 'folder/getList',
    GET_FOLDER_BY_ID: 'folder/get',
}

export const StatusCodes = {
    SUCCESS: 200,
    SUCCESS_WAIT: 210,
    NO_DATA_FOUND: 412,
    VALUE_NOT_ALLOWED: 413,
    AUTH_FAILED: 401,
    BAD_REQUEST: 400,
    INVALID_ACCESS: 403,
    INCORRECT_URL: 404,
    METHOD_NOT_SUPPORTED: 405,
    NOT_ACCEPTABLE: 406,
    REQUEST_TIMEOUT: 408,
    REQUEST_CANCELLED: 499,
    SERVER_ERROR: 500,
    DUPLICATE_DATA: 420,
    UNSUPPORTED_MEDIA_TYPE: 415
}

export const AxiosError = {
    code: StatusCodes.REQUEST_TIMEOUT,
    message: 'Request Timeout!!',
    description: 'Request Timeout of 15 seconds!',
}